<template>
  <modal
    :width="'582px'"
    :isShow.sync="createDialog"
    :title="title"
    :isShowBtn="[true, true]"
    :btnText="buttonText"
    @clickHandler="ClickHandler"
  >
    <div class="content">
      <el-form
        :model="formList"
        ref="createForm"
        :rules="rules"
        class="base-dialog"
      >
        <el-form-item
          v-for="item in formData"
          :key="item.name"
          :label="item.title"
          :prop="item.name"
        >
          <el-input
            v-if="item.type === 'text'"
            v-model="formList[item.name]"
            class="base-dialog-input"
            type="text"
            :placeholder="item.placeholder || '待获取'"
            @input="changeVal($event, item.name)"
            clearable
            :readonly="isEdit"
            maxlength="50"
          ></el-input>
          <div
            class="showText"
            :class="{
              emptyText: !formList[item.name] && formList[item.name] !== 0,
            }"
            v-if="item.type === 'show'"
          >
            {{
              item.name === "liveStatus"
                ? formatStatus(formList[item.name])
                : formList[item.name] || "待获取"
            }}
          </div>
          <el-image
            class="titlePicUrl"
            :close-on-click-modal="true"
            v-if="item.type === 'img' && formList[item.name]"
            :src="formList[item.name]"
            :preview-src-list="[formList[item.name]]"
            @click.stop="handleClickItem"
          />
          <div
            class="showText emptyText"
            v-if="item.type === 'img' && !formList[item.name]"
          >
            待获取
          </div>
          <el-radio-group
            v-if="item.type === 'radio'"
            v-model="formList[item.name]"
          >
            <el-radio :label="1">正式</el-radio>
            <el-radio :label="0">测试</el-radio>
          </el-radio-group>
          <div
            v-if="item.name === 'externalId' && !isEdit"
            class="get"
            @click="queryLiveFromPolyv"
          >
            获取
          </div>
        </el-form-item>
      </el-form>
    </div>
  </modal>
</template>

<script>
import modal from "@/components/modal";
import { request } from "@/utils/axios";
import TitlePicUrl from "@/assets/splashImg.png";

const formList_bak = {
  contentId: "",
  contentName: "",
  externalId: "",
  startTime: "",
  liveStatus: "",
  titlePicUrl: "",
  publisher: "",
  readerCount: "",
  liveUrl: "",
  liveMark: "",
};

export default {
  name: "createLiveModal",
  props: ["functionsId"],
  data() {
    return {
      loading: false,
      isEdit: false,
      createDialog: false,
      sourceType: null,
      formData: [
        {
          name: "externalId",
          type: "text",
          title: "直播ID",
          placeholder: "请输入直播ID",
        },
        {
          name: "contentName",
          type: "show",
          title: "直播名称",
        },
        {
          name: "startTime",
          type: "show",
          title: "直播时间",
        },
        {
          name: "liveStatus",
          type: "show",
          title: "直播状态",
        },
        {
          name: "titlePicUrl",
          type: "img",
          title: "直播引导图",
        },
        {
          name: "publisher",
          type: "show",
          title: "主讲人",
        },
        {
          name: "readerCount",
          type: "show",
          title: "累计观看人数",
        },
        {
          name: "liveUrl",
          type: "show",
          title: "直播链接",
        },
        {
          name: "liveMark",
          type: "radio",
          title: "直播形式",
        },
      ],
      formList: this.$commonJs.deepClone(formList_bak),
      rules: {
        externalId: [{ required: true, message: "直播ID不能为空" }],
        contentName: [{ required: true, message: "直播名称不能为空" }],
        startTime: [{ required: true, message: "直播时间不能为空" }],
        liveStatus: [{ required: true, message: "直播状态不能为空" }],
        liveUrl: [{ required: true, message: "直播链接不能为空" }],
        liveMark: [{ required: true, message: "直播形式不能为空" }],
      },
    };
  },
  computed: {
    buttonText() {
      if (this.isEdit) {
        return ["取消", "更新"];
      } else {
        return ["取消", "创建"];
      }
    },
    title() {
      if (this.isEdit) {
        return "编辑直播";
      } else {
        return "新建直播";
      }
    },
  },
  watch: {
    createDialog(val) {
      if (!val) {
        this.formList = this.$commonJs.deepClone(formList_bak);
        this.$refs["createForm"].resetFields();
        this.isEdit = false;
      }
    },
  },
  methods: {
    formatStatus(status) {
      // 直播状态格式化
      switch (status) {
        case 1:
          return "直播中";
        case 2:
          return "已结束";
        case 3:
          return "回放中";
        case 0:
          return "预告";
        default:
          return "待获取";
      }
    },
    ClickHandler(type) {
      if (type === "one") {
        this.createDialog = false;
      } else if (type === "two") {
        if (this.isEdit) {
          if (this.loading) return;
          this.loading = true;
          this.updateLive();
          // this.updateLive()
        } else {
          this.$refs["createForm"].validate((valid) => {
            if (valid) {
              if (this.loading) return;
              this.loading = true;
              this.submit();
            } else {
              console.log("error submit!!");
              return false;
            }
          });
        }
      }
    },
    updateLive() {
      const { startTime, liveStatus, readerCount, ...form } = this.formList;
      request(this.functionsId.updateLive, {
        tenantId: this.$commonJs.getTenantId(),
        ...form,
        contentLive: { startTime, liveStatus: +liveStatus },
        contentStatistics: { readerCount },
      })
        .then((res) => {
          this.$emit("updateLive");
          this.createDialog = false;
        })
        .catch((err) => {
          this.$message.error(err.msg);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    submit() {
      const { startTime, liveStatus, readerCount, ...form } = this.formList;
      request(this.functionsId.createLive, {
        tenantId: this.$commonJs.getTenantId(),
        ...form,
        contentLive: { startTime, liveStatus },
        contentStatistics: { readerCount },
        sourceType: this.sourceType,
      })
        .then((res) => {
          this.$emit("updateTableList");
          this.createDialog = false;
        })
        .catch((err) => {
          this.$message.error(err.msg);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    queryLiveFromPolyv() {
      if (!this.formList.externalId || this.loading) return;
      this.loading = true;
      request("health_cmp_biz_queryLiveFromPolyv", {
        polyvId: this.formList.externalId,
      })
        .then((res) => {
          const {
            contentLive: { liveStatus, startTime },
            liveUrl,
            contentName,
            publisher,
            titlePicUrl,
            contentStatistics: { readerCount },
            sourceType,
          } = res;
          this.formList = {
            ...this.formList,
            liveStatus: liveStatus || liveStatus === 0 ? liveStatus : "",
            liveUrl,
            contentName,
            publisher,
            titlePicUrl: titlePicUrl || TitlePicUrl,
            startTime: startTime ? startTime : "",
            readerCount,
          };
          this.sourceType = sourceType;
          this.$refs["createForm"].clearValidate();
        })
        .catch((err) => {
          this.$message.error(err.msg);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    changeVal(val, name) {
      if (name === "externalId" && val) {
        this.formList.externalId = val.replace(/[^\d]/g, "");
      }
    },
    getRow(row) {
      const { tenantId, createUser, createTime, subscribeCount, ...data } = row;
      this.isEdit = true;
      this.formList = {
        ...data,
        startTime: row.contentLive.startTime,
        liveStatus:
          row.contentLive.liveStatus || row.contentLive.liveStatus === 0
            ? row.contentLive.liveStatus
            : "",
        readerCount: row.contentStatistics.readerCount || "0",
      };
    },
    handleClickItem() {
      this.$nextTick(() => {
        // 获取遮罩层dom
        let domImageMask = document.querySelector(".el-image-viewer__mask");
        if (!domImageMask) {
          return;
        }
        domImageMask.addEventListener("click", () => {
          // 点击遮罩层时调用关闭按钮的 click 事件
          document.querySelector(".el-image-viewer__close").click();
        });
      });
    },
  },
  components: {
    modal,
  },
};
</script>

<style lang="scss" scoped>
.content {
  display: flex;
  justify-content: center;

  .base-dialog {
    width: 510px;
    padding: 30px 26px 0;
    position: relative;
    font-size: 14px;
    color: #2c3443;

    .showText {
      text-indent: 14px;
    }

    .emptyText {
      color: #c3cbd6;
    }

    :deep(.el-form-item__label) {
      width: 96px;
      font-weight: normal;
    }

    .el-form-item {
      margin-bottom: 6px;
    }

    .get {
      display: inline-block;
      width: 68px;
      height: 32px;
      line-height: 32px;
      margin-left: 12px;
      font-size: 14px;
      color: #ffffff;
      background-color: rgb(30, 82, 233);
      text-align: center;
      border-radius: 3px;
      cursor: pointer;
    }
    .titlePicUrl {
      width: 160px;
      max-height: 200px;
    }
    :deep(.base-dialog-input),
    :deep(.el-input__inner) {
      height: 32px;
      line-height: 32px;
    }
    :deep(.el-input__suffix),
    :deep(.el-input__icon) {
      height: 30px;
      line-height: 32px;
      top: 2px;
    }
    .input__inner {
      line-height: 32px;
    }
  }
  :deep(.el-icon-circle-close) {
    background-color: #ffffff;
  }
}
</style>
